import React from 'react';

const MarqueeSection = ({ title, images, direction = 'left' }) => {
  return (
    <div className={`marquee-${direction}`}>
      <h3>{title}</h3>
      <div className={`inner-${direction}`}>
        <div className={`scroll-content-${direction}`}>
          {[...Array(2)].map((_, i) => (
            <React.Fragment key={i}>
              {images.map((img, idx) => (
                <img key={`${title}-${i}-${idx}`} src={img} alt={`img-${idx}`} />
                // <LazyImage key={`${title}-${i}-${idx}`} src={img} alt={`img-${idx}`} />
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MarqueeSection;
